import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TagService } from '../services/tag.service';
import { TagCategory } from '../models/tag-category.model';
import { Tag } from '../models/tag.model';

@Component({
    selector: 'tag-button',
    templateUrl: './tag-button.component.html',
    styleUrls: ['./tag-button.component.scss']
})

export class TagButtonComponent implements OnInit {
    @Input() tag: Tag[];
    @Input() tagCategory: TagCategory[];
    @Input() expandedButton: boolean = false;
    @Input() altColor: boolean = false;
    @Output() tagUpdated = new EventEmitter<boolean>();
    @Input() addFocus: boolean = false;

    constructor(
       private tagService: TagService
       
        ) {
    }

    exceedMax: boolean  = false;

    ngOnInit() {

    }

    toggleTag(tag:Tag){
        // if max number of tags has not been selected, OR
        // if max number of tags HAS been selected, but user is trying to turn tag selected to false
        if(
            (!this.tagService.hitMaxSelectedTags) ||
            (this.tagService.hitMaxSelectedTags && tag.selected) 
        ) {
            tag.selected = !tag.selected;
            this.tagService.updateTagSelectedCount(tag);
            this.tagService.updateSavedTags(tag); 
            this.exceedMax = false;
        // else if max number of tags has been selected
        } else if(this.tagService.hitMaxSelectedTags) {
            this.exceedMax = true;    
        }

        this.tagService.emitTagUpdated(this.exceedMax);       
    }
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/tag-button/tag-button.component.ts